import { render, staticRenderFns } from "./MpUserList.vue?vue&type=template&id=2078c96c&scoped=true"
import script from "./MpUserList.vue?vue&type=script&lang=js"
export * from "./MpUserList.vue?vue&type=script&lang=js"
import style0 from "./MpUserList.vue?vue&type=style&index=0&id=2078c96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078c96c",
  null
  
)

export default component.exports